import PropTypes from "prop-types"
import parse from "html-react-parser"

import styles from "./returning_user_flow.module.scss"
import iftttLogoWhite from "images/logo-ifttt-white.svg?raw"
import arrow from "images/web/access_applet_card/arrow.svg?raw"

export default function Header(props) {
  const { services, idStrategy, connected, avatar, localization } = props

  return (
    <div className={styles.header}>
      <div className={styles.masthead}>
        <div className={styles["ifttt-logo"]}>
          {parse(iftttLogoWhite)}
        </div>
        <div className={styles.profile}>
          {avatar ? (
            <div
              className={styles.avatar}
              style={{ backgroundImage: `url(${avatar})` }}
            />
          ) : (
            <span>{idStrategy}</span>
          )}
        </div>
      </div>

      <div className={styles["header-content"]}>
        <div className={styles["service-to-service"]}>
          <div className={styles.service}>
            <img
              src={
                services[0].lrg_monochrome_image_url ||
                services[0].lrg_variant_image_url
              }
              title={services[0].name}
              alt={services[0].name}
            />
          </div>
          <div className={styles.arrow} title={localization.to} alt={localization.to}>
            {parse(arrow)}
          </div>
          <div className={styles.service}>
            <img
              src={
                services[1].lrg_monochrome_image_url ||
                services[1].lrg_variant_image_url
              }
              title={services[1].name}
              alt={services[1].name}
            />
          </div>
        </div>
        <p>
          {connected
            ? localization.connected_x_to_y
            : localization.connect_x_to_y}
        </p>
      </div>
    </div>
  )
}

Header.propTypes = {
  services: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      lrg_monochrome_image_url: PropTypes.string,
      lrg_variant_image_url: PropTypes.string,
    })
  ),
  idStrategy: PropTypes.string.isRequired,
  delayFadeInBy: PropTypes.number,
  connected: PropTypes.bool,
  avatar: PropTypes.string,
  localization: PropTypes.shape({
    connect_x_to_y: PropTypes.string.isRequired,
    connected_x_to_y: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
  }),
}

Header.defaultProps = {
  services: [],
  delayFadeInBy: 300,
  connected: false,
}
